module.exports = __webpack_public_path__ + "static/media/curve-silver.81d92861.svg";